module.exports = __webpack_public_path__ + "static/media/redChart.13542794.png";